"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDemembrementType = void 0;
exports.EDemembrementType = {
    temporaire: "temporaire",
    viager: "viager",
};
